import { ClienteTipo } from './cliente-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ClienteTipoService {

    constructor(private http: Http) {
    }

    getClienteTipos(): Observable<ClienteTipo[]> {
        return this.http.get(`${NTECH_API}/cliente-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/cliente-tipo/cliente-tipo.service.ts